export const categories = [
  {
    slug: "chise-jingling",
    name: "炽色精灵",
    description: "掌控火焰与热情之力的精灵一族，他们的色彩如烈焰般炽热耀眼，象征着勇气与激情。",
    colorTheme: "from-orange-400 to-red-500",
    icon: "ri-fire-line",
  },
  {
    slug: "senlin-jingling",
    name: "森林精灵",
    description: "栖息于翠绿森林中的精灵，与大自然融为一体，他们的色彩如春日新叶般生机盎然。",
    colorTheme: "from-emerald-400 to-green-600",
    icon: "ri-leaf-line",
  },
  {
    slug: "haidi-jingling",
    name: "海底精灵",
    description: "守护深海秘境的精灵，他们的色彩如珊瑚与珍珠般绚丽，散发着海洋的神秘光辉。",
    colorTheme: "from-cyan-400 to-teal-500",
    icon: "ri-drop-line",
  },
  {
    slug: "xingguang-jingling",
    name: "星光精灵",
    description: "来自星空深处的精灵使者，携带着银河的光芒，用璀璨色彩点亮黑夜的每一个角落。",
    colorTheme: "from-amber-300 to-yellow-500",
    icon: "ri-star-line",
  },
  {
    slug: "huanghun-jingling",
    name: "黄昏精灵",
    description: "在日落时分苏醒的精灵，拥有晚霞般温暖柔和的色彩，他们编织着一天中最美的光影。",
    colorTheme: "from-pink-400 to-rose-500",
    icon: "ri-sun-line",
  },
  {
    slug: "shuijing-jingling",
    name: "水晶精灵",
    description: "诞生于水晶矿脉中的精灵，通体晶莹剔透，能折射出七彩光芒，是色彩世界中最纯净的存在。",
    colorTheme: "from-violet-300 to-fuchsia-400",
    icon: "ri-vip-diamond-line",
  },
];